//------------------------------------------------------ externos
import { useState } from "react";
//------------------------------------------------------ elementos
//------------------------------------------------------ funciones
import Button from "../../buttons/Button";
import FormMovimientoStock from "../../formularios/events/FormMovimientoStock";
import FormStock from "../../formularios/FormStock";

const MovimientoStockAccess = ({
  typeForm = "articulo",
  type = "stock",
  title = null,
}) => {
  const TITLE = title || `${typeForm.toUpperCase()} (STOCK)`;
  const [formVisible, setFormVisible] = useState(false);

  const forms = {
    articulo: FormStock,
    movimiento: FormMovimientoStock,
  };

  const SelectedForm = forms[typeForm] || FormStock;

  const handleOpen = () => {
    setFormVisible(true);
  };

  const handleClose = () => {
    setFormVisible(false);
  };

  return (
    <>
      <Button text={TITLE} onClick={handleOpen} icono="stock" plus={true} />

      {formVisible && (
        <SelectedForm
          onGuardar={handleClose}
          type={type}
          onClose={handleClose}
        />
      )}
    </>
  );
};

export default MovimientoStockAccess;
